import React from 'react';

const Loading = () => {

    return (
        <div>
            <div className="d-flex justify-content-center">
                <div className="spinner-border" role="status">
                </div>
            </div>
        </div>

    );
};

export default Loading;